import { Box } from "@mui/material";
import {
  TAG_COLORS,
  TAG_ICONS,
} from "src/config/store/services/tags-api/types";
import { useIsMobileView } from "src/modules/shared/hooks/use-is-mobile-view";
import { TagIcon } from "../../../tag-icon/tag-icon";
import { classes, tagMarkerArrow } from "./tag-marker.styles";

type MarkerProps = {
  handleVideoProgress: (time: number) => void;
  marker: TagMarkerItem;
};

export type TagMarkerItem = {
  id: string;
  names: string[];
  position: number;
  color: keyof typeof TAG_COLORS;
  icons: TAG_ICONS[];
};

export const TagMarker = ({ handleVideoProgress, marker }: MarkerProps) => {
  const isMobile = useIsMobileView();

  const handleClick = () => {
    handleVideoProgress(marker.position);
  };

  return (
    <Box
      style={{
        left: `${marker.position}%`,
        backgroundColor: TAG_COLORS[marker.color],
        color: marker.color === "white" ? "black" : "white",
      }}
      sx={{
        ...classes.tagMarker,
        "&::after": {
          ...tagMarkerArrow,
          borderTopColor: TAG_COLORS[marker.color],
        },
      }}
      onClick={handleClick}
    >
      {isMobile ? (
        marker.icons.map((icon) => (
          <TagIcon key={icon} icon={icon} color="black" size={20} />
        ))
      ) : (
        <>
          <span className="title"> JUMP TO</span>
          {marker.names.map((name, index, array) => (
            <Box key={name} sx={classes.markerName}>
              <span key={name}>{name}</span>

              {array.length - 1 !== index && <span>&</span>}
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};
